var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.auth == false)?_c('div',[_c('CardConfirmAuth')],1):_c('div',[_c('CardUserAuth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }